module.exports = __webpack_public_path__ + "static/media/inhaler.23154986.svg";